import styled from 'styled-components';
import { StyledDivComponent } from '../types';
import { defaults } from '../theme/base/defaults';

export const Image = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
  display: block;
  transition: border-color 0.2s;
`;

export const ImageZoom: StyledDivComponent = styled.div`
  cursor: pointer;
`;

export const ImageDescription = styled.p`
    padding: 10px 0 10px;
    font-size: 1.8rem;
    font-weight: 300;
    @media (max-width: ${defaults.breakpoints.medium}px) {
        padding: 5px 0 15px;
        font-size: 1.6rem;
    }
`;
